/**
 * Hero Section
 * Main banner with title and call-to-action
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { usePortal } from '../../context/PortalContext';

const HeroSection = ({ 
  title, 
  subtitle, 
  ctaText = 'Shop Now', 
  ctaLink = '/products',
  backgroundImage 
}) => {
  const { branding } = usePortal();

  return (
    <section style={{
      ...styles.hero,
      background: backgroundImage 
        ? `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${backgroundImage}) center/cover`
        : `linear-gradient(135deg, ${branding.primaryColor} 0%, ${branding.secondaryColor} 100%)`,
    }}>
      <div style={styles.content}>
        <h1 style={styles.title}>{title || branding.businessName}</h1>
        <p style={styles.subtitle}>{subtitle || 'Welcome to our store'}</p>
        <Link to={ctaLink} style={styles.cta}>
          {ctaText}
        </Link>
      </div>
    </section>
  );
};

const styles = {
  hero: {
    minHeight: '80vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    color: 'white',
    marginTop: '80px', // Account for fixed header
  },
  content: {
    maxWidth: '800px',
    padding: '40px 20px',
  },
  title: {
    fontSize: 'clamp(2.1rem, 6vw, 3.5rem)',
    fontWeight: '700',
    marginBottom: '20px',
    lineHeight: 1.15,
    textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
  },
  subtitle: {
    fontSize: 'clamp(1rem, 2.5vw, 1.3rem)',
    marginBottom: '30px',
    opacity: '0.9',
  },
  cta: {
    display: 'inline-block',
    padding: '15px 32px',
    background: 'white',
    color: '#333',
    textDecoration: 'none',
    borderRadius: '50px',
    fontWeight: '600',
    fontSize: '1.1rem',
    transition: 'transform 0.3s, box-shadow 0.3s',
    boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
  },
};

export default HeroSection;
